import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subError, setSubError] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('phone_alt') as string || '').trim();
    if (honeypotVal) {
      setSubStatus('success');
      setEmail('');
      return;
    }
    if (!email.trim()) return;
    setSubStatus('loading');
    setSubError('');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email.trim());
      const res = await fetch('http://aetws.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '订阅失败，请稍后重试';
        if (msg.toLowerCase().includes('spam') || msg.includes('spam')) {
          setSubError('订阅失败，请稍后重试');
        } else {
          setSubError(msg);
        }
        setSubStatus('error');
      }
    } catch {
      setSubError('网络错误，请稍后重试');
      setSubStatus('error');
    }
  };

  return (
    <footer className="bg-secondary-700 text-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 mb-5 no-underline">
              <div className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center">
                <i className="ri-book-open-line text-secondary-700 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                韩漫漫画网
              </span>
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed mb-6 max-w-xs">
              免费韩漫在线阅读平台，提供高清韩国漫画下拉式阅读体验，每日更新，畅享海量漫画资源。
            </p>
            <form onSubmit={handleSubscribe} className="max-w-xs">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="antispam-field"
              />
              <div className="bg-secondary-600 rounded-xl px-4 py-3 flex items-center gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱获取更新通知"
                  className="bg-transparent border-none outline-none text-background-50 text-sm flex-1 placeholder:text-background-50/50"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  disabled={subStatus === 'loading'}
                  className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center cursor-pointer hover:bg-accent-600 transition-colors whitespace-nowrap disabled:opacity-50"
                  aria-label="订阅"
                >
                  <i className="ri-notification-3-line text-background-50 text-sm"></i>
                </button>
              </div>
              {subStatus === 'success' && (
                <p className="text-accent-500 text-xs mt-2">订阅成功！感谢您的关注。</p>
              )}
              {subStatus === 'error' && (
                <p className="text-red-400 text-xs mt-2">{subError}</p>
              )}
            </form>
          </div>
          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
                <a href="/category/remen" className="text-background-50 hover:text-accent-500 transition-colors no-underline">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/remen', label: '热门推荐' },
                  { to: '/category/zuixin', label: '最新上架' },
                  { to: '/category/wanjie', label: '完结漫画' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-background-50/70 text-sm hover:text-accent-500 transition-colors whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">
                <a href="/category/lianai" className="text-background-50 hover:text-accent-500 transition-colors no-underline">类型分类</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/lianai', label: '恋爱漫画' },
                  { to: '/category/qihuan', label: '奇幻冒险' },
                  { to: '/category/dongzuo', label: '动作热血' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-background-50/70 text-sm hover:text-accent-500 transition-colors whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">平台信息</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/about', label: '关于我们' },
                  { to: '/about', label: '商务合作' },
                  { to: '/about', label: '联系我们' },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-background-50/70 text-sm hover:text-accent-500 transition-colors whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-background-50">帮助中心</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/about', label: '常见问题' },
                  { to: '/about', label: '使用指南' },
                  { to: '/about', label: '意见反馈' },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-background-50/70 text-sm hover:text-accent-500 transition-colors whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-background-50/10">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/50 text-xs whitespace-nowrap">
            &copy; {new Date().getFullYear()} 韩漫漫画网 - 免费韩漫在线阅读平台
          </p>
          <div className="flex items-center gap-3">
            {['ri-wechat-line', 'ri-links-line', 'ri-movie-line', 'ri-tiktok-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 rounded-lg border border-background-50/30 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                aria-label={icon.replace('ri-', '').replace('-line', '')}
                rel="nofollow"
              >
                <i className={`${icon} text-background-50 text-sm`}></i>
              </a>
            ))}
          </div>
          <a href="/about" className="text-background-50/50 text-xs hover:text-accent-500 transition-colors whitespace-nowrap">
            隐私政策
          </a>
        </div>
      </div>
    </footer>
  );
}